import { Badge, Col, Row } from "react-bootstrap";
import { getJeepRallyMediaUrl } from "../../../../../../api/jeep-rally/api";
import { getCategoryRouteSummary } from "../../../Categories/utils/category.utils";
import {
  getRallyCategories,
  getRallyCategoryLabel,
  getRallyPricingMap,
} from "../../utils/rally.utils";

const DetailItem = ({ label, children }) => (
  <div className="mb-2">
    <div className="text-muted small mb-1">{label}</div>
    <div>{children ?? "-"}</div>
  </div>
);

const RallyCategorySection = ({ rally }) => {
  const categories = getRallyCategories(rally);
  const pricingMap = getRallyPricingMap(rally);

  return (
    <div className="mb-4">
      <h5 className="mb-3">Categories</h5>

      {!categories.length ? (
        <p className="text-muted mb-0">
          No categories assigned. Edit this rally to assign one or more
          categories.
        </p>
      ) : (
        <Row>
          {categories.map((category, idx) => {
            const isObject = category && typeof category === "object";
            const title = getRallyCategoryLabel(category) || "-";
            const categoryImage = isObject
              ? getJeepRallyMediaUrl(category.image)
              : "";
            const key = isObject ? category._id || category.id || category.key : title;

            return (
              <Col md={6} lg={4} key={`${key}-${idx}`} className="mb-3">
                <div
                  className="h-100 p-3 border rounded"
                  style={{ background: "#fafbfc" }}
                >
                  {categoryImage ? (
                    <img
                      src={categoryImage}
                      alt={title}
                      style={{
                        width: "100%",
                        height: "120px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #dee2e6",
                        display: "block",
                        marginBottom: 12,
                      }}
                    />
                  ) : null}

                  <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                    <h6 className="mb-0">{title}</h6>
                    {isObject && category.key && category.key !== title ? (
                      <Badge bg="secondary">{category.key}</Badge>
                    ) : null}
                  </div>

                  {isObject ? (
                    <>
                      {category.description ? (
                        <p className="text-muted small mb-2">
                          {category.description}
                        </p>
                      ) : null}
                      <DetailItem label="Max members">
                        {category.max_members ?? "-"}
                      </DetailItem>
                      <DetailItem label="Navigator allowed">
                        {category.navigator_allowed ? "Yes" : "No"}
                      </DetailItem>
                      <DetailItem label="Price">
                        {pricingMap[
                          isObject ? category._id || category.id : category
                        ] ?? "-"}
                      </DetailItem>
                      <DetailItem label="Route">
                        {getCategoryRouteSummary(category)}
                      </DetailItem>
                    </>
                  ) : null}
                </div>
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
};

export default RallyCategorySection;
